function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "595.28px",
    viewBox: "0 0 427.035 437.889",
    enableBackground: "new 0 0 595.28 595.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -84.217987, -79.745308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.831,104.194H113.446c-14.596,0-26.471,11.874-26.471,26.472c0,14.596,11.875,26.472,26.471,26.472h3.5 v250.46c0,4.501,3.648,8.146,8.145,8.146h345.099c4.496,0,8.145-3.645,8.145-8.146v-250.46h3.497 c14.598,0,26.474-11.876,26.474-26.472C508.305,116.068,496.429,104.194,481.831,104.194z M462.044,399.453H133.235V157.138 h328.809V399.453z M481.831,140.848h-11.642H125.091h-11.645c-5.613,0-10.182-4.57-10.182-10.182 c0-5.614,4.568-10.184,10.182-10.184h368.385c5.614,0,10.184,4.569,10.184,10.184C492.015,136.277,487.445,140.848,481.831,140.848 z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.767,375.697h38.013c4.497,0,8.146-3.646,8.146-8.145V267.097c0-4.499-3.648-8.147-8.146-8.147h-38.013 c-4.497,0-8.145,3.648-8.145,8.147v100.456C173.622,372.052,177.27,375.697,181.767,375.697z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.625,375.697h38.009c4.499,0,8.145-3.646,8.145-8.145V233.159c0-4.497-3.646-8.146-8.145-8.146h-38.009 c-4.499,0-8.145,3.648-8.145,8.146v134.394C267.48,372.052,271.126,375.697,275.625,375.697z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.481,375.697h38.011c4.499,0,8.147-3.646,8.147-8.145V195.148c0-4.499-3.648-8.147-8.147-8.147h-38.011 c-4.497,0-8.146,3.648-8.146,8.147v172.404C361.336,372.052,364.984,375.697,369.481,375.697z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.775,89.939c0-4.497-3.646-8.145-8.147-8.145c-4.496,0-8.145,3.647-8.145,8.145v8.145h16.292V89.939z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.221,498.104l-70.445-36.413v-39.838h-16.292v39.838l-70.445,36.413 c-3.994,2.065-5.559,6.98-3.495,10.977c1.447,2.8,4.294,4.404,7.243,4.404c1.258,0,2.535-0.291,3.733-0.908l71.108-36.755 l71.111,36.755c1.197,0.617,2.476,0.908,3.735,0.908c2.947,0,5.797-1.604,7.243-4.404 C378.781,505.085,377.217,500.17,373.221,498.104z",
    style: {
      fill: "rgba(246, 246, 246, 0.42)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.5690b4ce.svg";
export { ForwardRef as ReactComponent };